import 'react-app-polyfill/ie11';
import { render } from 'react-dom';

import './shared/styles/index.css';
import App from './App';

render(<App />, document.getElementById('root'));
